export const formatTxURL = (signature, cluster = undefined) => {
    return `https://explorer.solana.com/tx/${signature}${cluster && `?cluster=${cluster}`}`
}
